export default "__VITE_ASSET__fa3bfe57__"